import React from 'react';


export default function ThankYou() {

  
  return (
    <div className="container">
      <div>
       {/* <script src="https://www.google.com/recaptcha/api.js" 
                            async defer></script>
                    <div class="g-recaptcha" id="feedback-recaptcha" 
                         data-sitekey="{{ env('6LdWE0MqAAAAAPEFH02nZte7cGR3pw3GHufoIhU0') }}">
                    </div> */}
                    
                  
                    {/* <div className="flex items-baseline justify-between">
                        <button onClick={handleSubmit} disabled={!submitEnabled} type="submit" className={`${submitEnabled ? 'bg-blue-600 hover:bg-blue-900' : 'bg-gray-600 cursor-not-allowed'} px-6 py-2 mt-4 text-white  rounded-lg `}>Login</button>
                    </div> */}
                    </div>
                    <br/><br/><br/><br/><br/><br/>
      <h1>Thank You!</h1>
      <p>Your form has been successfully submitted.</p>
    </div>
  );
}





